import { cn } from '@/lib/utils'

interface SectionHeadingProps {
  title: string
  subtitle?: string
  centered?: boolean
  light?: boolean
  accent?: boolean
  className?: string
}

export function SectionHeading({
  title,
  subtitle,
  centered = false,
  light = false,
  accent = false,
  className,
}: SectionHeadingProps) {
  return (
    <div className={cn('max-w-3xl', centered && 'mx-auto text-center', className)}>
      <h2
        className={cn(
          'text-h2',
          accent ? 'text-primary' : light ? 'text-white' : 'text-ink'
        )}
      >
        {title}
      </h2>
      {subtitle && (
        <p
          className={cn(
            'mt-4 text-lead',
            light ? 'text-white/80' : 'text-muted'
          )}
        >
          {subtitle}
        </p>
      )}
    </div>
  )
}
